import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {ScrollingModule} from "@angular/cdk/scrolling";
import {MatMenuModule} from "@angular/material/menu";
import {TranslateModule} from "@ngx-translate/core";
import {
  BzButton, BzCard, BzCheckbox, BzCopyButton, BzDivider, BzEmptyState, BzFormField, BzIcon, BzInput, BzMenu, BzRadio, BzRadioGroup,
  BzSearchInput, BzSelect, BzSkeleton, BzSpinner, BzSwitch, BzTable, BzTableHeaderDef, BzTableRowDef, BzTabs, BzTag,
} from "@bringoz/ui";
import {GoogleMapsModule} from "@angular/google-maps";
import {NgxPermissionsModule} from "ngx-permissions";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {AccountsModule} from "../../account/angular/accounts.module";
import {ServicesModule} from "../../deliveries/angular/services.module";
import {CommonsModule} from "../../commons/angular/commons.module";
import {ThreeplTrainVouchersViewComponent} from "./components/threepl-train-vouchers-view/threepl-train-vouchers-view.component";
import {ThreeplTrainVouchersTableComponent} from "./components/threepl-train-vouchers-table/threepl-train-vouchers-table.component";
import {ThreeplTrainVouchersTableRowComponent} from "./components/threepl-train-vouchers-table-row/threepl-train-vouchers-table-row.component";
import {ThreeplEditTrainVoucherViewComponent} from "./components/threepl-edit-train-voucher-view/threepl-edit-train-voucher-view.component";
import {ThreeplTrainVoucherContainersTableComponent} from "./components/threepl-train-voucher-containers-table/threepl-train-voucher-containers-table.component";
import {ThreeplTrainVoucherContainersTableRowComponent} from "./components/threepl-train-voucher-containers-table-row/threepl-train-voucher-containers-table-row.component";
import {VouchersPrintPageComponent} from "./components/vouchers-print-page/vouchers-print-page.component";
import {ThreeplServiceLinkComponent} from "./components/threepl-service-link/threepl-service-link.component";
import {ThreeplCreateTrainVoucherViewComponent} from "./components/threepl-create-train-voucher-view/threepl-create-train-voucher-view.component";
import {ThreeplSupplyAccountSelectComponent} from "./components/threepl-supply-account-select/threepl-supply-account-select.component";
import {ThreeplSupplyAccountSelectPanelComponent} from "./components/threepl-supply-account-select-panel/threepl-supply-account-select-panel.component";
import {ThreeplServiceViewComponent} from "./components/threepl-service-view/threepl-service-view.component";
import {ThreeplServiceTaskComponent} from "./components/threepl-service-task/threepl-service-task.component";
import {ThreeplServiceActionsComponent} from "./components/threepl-service-actions/threepl-service-actions.component";
import {ThreeplServiceTimelineComponent} from "./components/threepl-service-timeline/threepl-service-timeline.component";
import {ThreeplServiceMapComponent} from "./components/threepl-service-map/threepl-service-map.component";
import {ThreeplProviderExtraDataViewComponent} from "./components/threepl-provider-extra-data-view/threepl-provider-extra-data-view.component";
import {ThreeplServicesViewComponent} from "./components/threepl-services-view/threepl-services-view.component";
import {ThreeplServicesTableComponent} from "./components/threepl-services-table/threepl-services-table.component";
import {ThreeplServicesTableRowComponent} from "./components/threepl-services-table-row/threepl-services-table-row.component";
import {ThreeplServicesTableItemComponent} from "./components/threepl-services-table-item/threepl-services-table-item.component";
import {ThreeplServicesSettingsPanelComponent} from "./components/threepl-services-settings-panel/threepl-services-settings-panel.component";
import {ThreeplServicesSettingsPanelContentComponent} from "./components/threepl-services-settings-panel-content/threepl-services-settings-panel-content.component";
import {ThreeplServicesGroupStatusSelectComponent} from "./components/threepl-services-group-status-select/threepl-services-group-status-select.component";
import {ThreeplServiceStatusSelectorComponent} from "./components/threepl-service-status-selector/threepl-service-status-selector.component";
import {ThreeplServiceActionFooterComponent} from "./components/threepl-service-action-footer/threepl-service-action-footer.component";
import {ThreeplServicesTotalsIndicationComponent} from "./components/threepl-services-totals-indication/threepl-services-totals-indication.component";
import {ThreeplServicePackagesIndicationComponent} from "./components/threepl-service-packages-indication/threepl-service-packages-indication.component";
import {AccountThreeplServicesComponent} from "./components/account-threepl-services/account-threepl-services.component";
import {ThreeplServiceChipsComponent} from "./components/threepl-service-chips/threepl-service-chips.component";
import {ProviderTypeMultiSelectListComponent} from "./components/provider-type-multi-select-list/provider-type-multi-select-list.component";
import {ProviderTypesDisplayListComponent} from "./components/provider-types-display-list/provider-types-display-list.component";
import {ThreeplStatusTonePipe} from "./pipes/threepl-status-tone.pipe";
import {ThreeplServicesTableSkeletonRowComponent} from "./components/threepl-services-table-skeleton-row/threepl-services-table-skeleton-row.component";

@NgModule({
  declarations: [
    ThreeplTrainVouchersViewComponent,
    ThreeplTrainVouchersTableComponent,
    ThreeplTrainVouchersTableRowComponent,
    ThreeplEditTrainVoucherViewComponent,
    ThreeplTrainVoucherContainersTableComponent,
    ThreeplTrainVoucherContainersTableRowComponent,
    VouchersPrintPageComponent,
    ThreeplServiceLinkComponent,
    ThreeplCreateTrainVoucherViewComponent,
    ThreeplSupplyAccountSelectComponent,
    ThreeplSupplyAccountSelectPanelComponent,
    ThreeplServiceViewComponent,
    ThreeplServiceTaskComponent,
    ThreeplServiceActionsComponent,
    ThreeplServiceTimelineComponent,
    ThreeplServiceMapComponent,
    ThreeplProviderExtraDataViewComponent,
    ThreeplServicesViewComponent,
    ThreeplServicesTableComponent,
    ThreeplServicesTableRowComponent,
    ThreeplServicesTableItemComponent,
    ThreeplServicesSettingsPanelComponent,
    ThreeplServicesSettingsPanelContentComponent,
    ThreeplServicesGroupStatusSelectComponent,
    ThreeplServiceStatusSelectorComponent,
    ThreeplServiceActionFooterComponent,
    ThreeplServicesTotalsIndicationComponent,
    ThreeplServicePackagesIndicationComponent,
    AccountThreeplServicesComponent,
    ThreeplServiceChipsComponent,
    ProviderTypeMultiSelectListComponent,
    ProviderTypesDisplayListComponent,
    ThreeplServicesTableSkeletonRowComponent,
    ThreeplStatusTonePipe,
  ],
  imports: [
    CommonModule,
    CommonsModule,
    TranslateModule.forChild(),
    NgxPermissionsModule.forChild(),
    NgbModule,
    GoogleMapsModule,
    ScrollingModule,
    MatMenuModule,
    AccountsModule,
    ServicesModule,
    BzButton, BzCard, BzCheckbox, BzCopyButton, BzDivider, BzEmptyState, BzFormField, BzIcon, BzInput, BzMenu, BzRadio, BzRadioGroup,
    BzSearchInput, BzSelect, BzSkeleton, BzSpinner, BzSwitch, BzTable, BzTableHeaderDef, BzTableRowDef, BzTabs, BzTag,
  ],
})
export class ThreePLModule {}
